// @file Helper methods for the user model

/* eslint-disable @typescript-eslint/camelcase */
import { __ } from 'bits/intl'
import { User } from 'types'

export const ROLE_MAP = {
  owner: __('owner'),
  admin: __('admin'),
  teacher: __('teacher'),
  student: __('student'),
  member: __('member'),
}

export enum UserRole {
  OWNER = 'owner',
  TEACHER = 'teacher',
  ADMIN = 'admin',
  STUDENT = 'student',
  MEMBER = 'member',
  DEFAULT = '',
}

export const anonymous = __('Anonymous')
export const ANONYMOUS_AVATAR = 'https://padlet.net/avatars/alien1.png' // copied from library/v4/components/OzAvatar.vue
export const blankUser = (): User => {
  return {
    id: -1,
    avatar: ANONYMOUS_AVATAR,
    tenant_id: 1,
    paying: false,
    quota: {
      walls_used: 0,
      walls_limit: 0,
      advertized_walls_limit: 0,
      can_make: false,
    },
    role: 'student',
    lang: 'en',
    created_at: new Date(),
    registered_at: new Date(),
    name: anonymous,
    email: undefined,
    short_name: undefined,
    registered: false,
    profile_url: null,
  }
}

export function translatedRole(role: UserRole): string {
  return ROLE_MAP[role]
}
